import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { showCallerEntryModal } from '../../../../actions/modal.js';
import { updateCallerEntryURL, callerEntryPointUrlInUse } from '../../../../actions/waitingArea.js';
import { isStringEmpty } from '../../../../businessLogic/validation.js';

export default function RightPanelSuspendWaitingArea(props) {
  const dispatch = useDispatch();
  const [updatingCallerEntryPoint, setUpdatingCallerEntryPoint] = useState(false);

  useEffect(() => {
    if (props.updateOrView == 'update' && props.messageData) {
      if (props.messageData.text.toString().indexOf('The short URL extension') != -1) {
        if (window.$('input[name="AAHostedURLInput"]').length > 0) {
          window.$('input[name="AAHostedURLInput"]').focus();
        }
      }
    }
  }, [props.messageData]);

  const closeModal = () => {
    dispatch(showCallerEntryModal(false));
  };

  const saveURLChanges = () => {
    setUpdatingCallerEntryPoint(true);

    let cb = (hideModal, err) => {
      setUpdatingCallerEntryPoint(false);
      dispatch(showCallerEntryModal(!hideModal));

      if (err == 'WaitingAreaDuplicateShortUrl') {
        if (window.$('input[name="AAHostedURLInput"]').length > 0) {
          window.$('input[name="AAHostedURLInput"]').focus();
        }
        dispatch(callerEntryPointUrlInUse(true));
        forceValidation(undefined, undefined, 'callerEntryPage');
      }
    };

    let payload = {
      customUrl: props.callerEntryPointForm.customUrl,
      shortUrl: props.callerEntryPointForm.shortUrl,
      isWaitingAreaPublic: props.callerEntryPointForm.isWaitingAreaPublic,
    };
    dispatch(updateCallerEntryURL(props.waitingArea.id, payload, cb));
  };

  const saveModal = (event) => {
    let areThereErrors = forceValidation(undefined, undefined, 'callerEntryPage');
    if (!areThereErrors && !window.$(event.target).hasClass('disable')) {
      saveURLChanges();
    }
  };

  let saveClasses =
    'ui approve entry-point-save-btn labeled icon button icon left-text color-button color-button-hover mrrxs color-white max-width mrbm mrlnull mrbnull';
  let closeButton = (
    <button
      onClick={closeModal}
      type="button"
      className="ui cancel labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrlnull mrbnull"
    >
      <i className="remove  icon" />
      {APP.LANGUAGE.Close}
    </button>
  );
  return (
    <div>
      {props.updateOrView == 'update' ? (
        <div className=" mrbs max-width">
          <button
            name="callerEntryPointSaveBtn"
            type="button"
            className={updatingCallerEntryPoint ? saveClasses + ' loading' : saveClasses}
            data-group="callerEntryPage"
            onClick={saveModal}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark icon " />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={closeModal}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className=" mrbs max-width">
          <button
            onClick={closeModal}
            type="button"
            className="ui cancel labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
    </div>
  );
}
